export default __webpack_public_path__ + "static/media/moov.c7202efb.png";